import { giphyGreen } from '@giphy/colors'
import { ReactNode, useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'

const stripeAnimation = keyframes`
    0% { transform: translate3d(0, 0, 0); }
    100% { transform: translate3d(-60px, 0, 0); }
`

const Container = styled.div`
    border-radius: inherit;
    display: flex;
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 100%;
`

const Progress = styled.div`
    background: ${giphyGreen};
    height: 100%;
    overflow: hidden;
    transform: translate3d(-100%, 0, 0);
    transition: transform 3s ease-out;
    width: 100%;
`

const Stripes = styled.div`
    animation: ${stripeAnimation} 0.7s linear 0s infinite;
    background: repeating-linear-gradient(
        -45deg,
        rgba(0, 0, 0, 0.05),
        rgba(0, 0, 0, 0.05) 10px,
        rgba(0, 0, 0, 0) 10px,
        rgba(0, 0, 0, 0) 20px
    );
    box-sizing: content-box;
    height: 100%;
    left: 0;
    padding-right: 60px;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    className?: string
    children?: ReactNode
    progress: number
}

const CreationToolsProgressBar = ({ className, children, progress }: Props) => {
    const [displayProgress, setDisplayProgress] = useState<number>(0)

    useEffect(() => {
        const delay = setTimeout(() => {
            setDisplayProgress(progress)
        }, 100)

        return () => {
            clearTimeout(delay)
        }
    }, [progress])

    return (
        <Container className={className}>
            <Progress style={{ transform: `translate3d(${(displayProgress - 1) * 100}%, 0, 0)` }}>
                <Stripes />
            </Progress>
            {children}
        </Container>
    )
}

export default CreationToolsProgressBar
